export default "__VITE_ASSET__ff654735__"